import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "./locales/en/translation.json";
import hi from "./locales/hi/translation.json";

// Load saved language from localStorage
const getSavedLanguage = () => {
  try {
    const saved = localStorage.getItem('i18nextLng') || localStorage.getItem('selectedLanguage');
    if (saved === 'hi' || saved === 'en') {
      return saved;
    }
  } catch (error) {
  }
  return 'en'; // Default to English
};

i18n
  .use(LanguageDetector) // auto-detects user's language
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      hi: { translation: hi },
    },
    fallbackLng: "hi", // default language (currently your app is in Hindi)
    lng: getSavedLanguage(),
    interpolation: {
      escapeValue: false, // React already handles XSS
    },
  });

// Save language to localStorage whenever it changes
i18n.on('languageChanged', (lng) => {
  try {
    localStorage.setItem('selectedLanguage', lng);
    localStorage.setItem('i18nextLng', lng);
  } catch (error) {
  }
});

export default i18n;
